export enum PeriodOption {
  THIS_WEEK = "THIS_WEEK",
  THIS_MONTH = "THIS_MONTH",
  LAST_MONTH = "LAST_MONTH",
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
  CUSTOM = "CUSTOM",
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface DateRangeSelectorProps {
  selectedPeriod: PeriodOption;
  customDateRange?: DateRange;
  onPeriodChange: (period: PeriodOption) => void;
  onCustomDateRangeChange?: (dateRange: DateRange) => void;
  excludedPeriods?: PeriodOption[];
}
